const debouceDefaultValue = 250
/**
 * Calls the same function once at giving time
 * @param {Function} callback
 * @param {Number} time
 * @returns {Function} function, with a `cancel` method that drops the pending call
 */
const debounce = (callback, time = debouceDefaultValue) => {
	let interval
	const debounced = (...args) => {
		clearTimeout(interval)
		interval = setTimeout(() => {
			interval = null
			callback(...args)
		}, time)
	}
	debounced.cancel = () => {
		clearTimeout(interval)
		interval = null
	}
	return debounced
}

export default debounce
